// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_18_1-row {
  /* Colors */
  --perxis-auto-row-background-color-default-inner: var(--perxis-auto-row-background-color-default, transparent);
  --perxis-auto-row-background-color-dark-inner: var(--perxis-auto-row-background-color-dark, var(--perxis-auto-root-seventh-color-inner));
  --perxis-auto-row-background-color-light-inner: var(--perxis-auto-row-background-color-light, var(--perxis-auto-root-first-color-inner));
  /* End Colors */
  background: var(--perxis-auto-row-background-color-default-inner);
}
.perxis-auto-1_18_1-row-background-dark {
  background: var(--perxis-auto-row-background-color-dark-inner);
}
.perxis-auto-1_18_1-row-background-light {
  background: var(--perxis-auto-row-background-color-light-inner);
}

.perxis-auto-1_18_1-col {
  /* Colors */
  --perxis-auto-col-background-color-default-inner: var(--perxis-auto-col-background-color-default, transparent);
  --perxis-auto-col-background-color-dark-inner: var(--perxis-auto-col-background-color-dark, var(--perxis-auto-root-seventh-color-inner));
  --perxis-auto-col-background-color-light-inner: var(--perxis-auto-col-background-color-light, var(--perxis-auto-root-first-color-inner));
  /* End Colors */
  background: var(--perxis-auto-col-background-color-default-inner);
}
.perxis-auto-1_18_1-col-background-dark {
  background: var(--perxis-auto-col-background-color-dark-inner);
}
.perxis-auto-1_18_1-col-background-light {
  background: var(--perxis-auto-col-background-color-light-inner);
}
.perxis-auto-1_18_1-col.ant-5_24_1-col {
  min-height: initial;
}
.perxis-auto-1_18_1-col.ant-5_24_1-col:empty {
  display: none;
}

[class^=ant-5_24_1-row], [class*=" ant-5_24_1-row"], [class^=ant-5_24_1-col], [class*=" ant-5_24_1-col"] {
  font-family: inherit;
  font-size: inherit;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
